module.exports = __webpack_public_path__ + "img/notification-outline.625057ef.svg";